define(['jQuery', 'toolkit/b-layer/b-layer', 'toolkit/b-spinner/b-spinner'], (
    $,
    BLayer /* , BSpinner*/,
) => {
    return BLayer.extend('wait-layer', {
        inner: true,
        renderMode: 'replace',
        canHide: false,

        init() {
            this.templateBlock = 'b-layer';

            // eslint-disable-next-line prefer-rest-params
            BLayer.fn.init.apply(this, arguments);
        },

        getData() {
            // eslint-disable-next-line prefer-rest-params
            let data = BLayer.fn.getData.apply(this, arguments);

            data = $.extend(
                {},
                {
                    block: 'b-spinner',
                    classes: ['wait-layer'],
                    params: {
                        mods: ['svg'],
                        classes: ['wait-layer__spinner'],
                        text: data.text,
                    },
                },
            );

            return data;
        },
    });
});
